import { Field, useFormikContext } from "formik";
import {
  Box,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import useCabinetOptions from "../../../../hooks/useCabinetOptions";
import { FormRadioWrapper } from "./AccessSettings";
import { useTranslation } from "react-i18next";

const BaseCabinetOption = () => {
  const { t } = useTranslation();
  const { base } = useCabinetOptions();
  const { setFieldValue, values } = useFormikContext();

  return (
    <Box className="optionsWrapper">
      <Box className="separation-border w-100 p-2">
        {base?.map((option) => (
          <FormRadioWrapper 
            key={option.id}
            subLabel={option.description}
          >
            <Field
                type="radio"
                name="setting_id"
                className="radio-input"
                value={option.id}
                checked={values.setting_id === option.id}
                onChange={(e) => {
                    setFieldValue("setting_id", Number(e.target.value));
                    setFieldValue("my_department_id", null);
                    setFieldValue("my_dept_ids", []);
                    setFieldValue("other_department_id", null);
                    setFieldValue("other_dept_ids", []);
                    setFieldValue("from_branches", []);
                    setFieldValue("from_departments", []);
                    setFieldValue("referrals", []);
                }}
            />
            <Box>
              <SpanStyled
                as="label"
                size="16px"
                color="var(--text)"
                checked={Number(values.setting_id) === option.id}
                className="radio-label"
              >
                {option.title}
              </SpanStyled>
              <TextStyled
                size="14px"
                weight="300"
                color="var(--text2)"
                checked={Number(values.setting_id) === option.id}
              >
                {option.description}
              </TextStyled>
            </Box>
          </FormRadioWrapper>
        ))}
      </Box>
    </Box>
  );
};

export default BaseCabinetOption;
